<template>
  <div>
    <new-group :toggle="show_new_group" @created="getGroups" />
    <b-modal
      title="Nova permissão"
      :visible="show"
      hide-footer
      no-close-on-backdrop
      @show="evOnShow"
      @shown="evOnShown"
      @hide="evOnHide"
    >
      <b-overlay :show="loading" opacity="0.99">
        <b-form @submit.prevent="evOnSubmit">
          <warning-required-fields />
          <errors-messages :errors="errors" />
          <b-row>
            <b-col cols="12">
              <label-required-field label="Módulo" />
              <b-select
                :options="modules"
                v-model="module_id"
                text-field="description"
                value-field="id"
              />
            </b-col>
            <b-col cols="12">
              <label-required-field label="Grupo" />
              <b-input-group>
                <b-select
                  :options="groups"
                  v-model="group_id"
                  text-field="name"
                  value-field="id"
                />
                <template #append>
                  <v-btn
                    class="v-primary"
                    @click="show_new_group = !show_new_group"
                  >
                    <v-icon class="mr-1">mdi-plus</v-icon>
                    NOVO
                  </v-btn>
                </template>
              </b-input-group>
            </b-col>
            <b-col cols="6">
              <label-required-field label="Nome" />
              <b-input ref="autofocus" v-model="name" />
            </b-col>
            <b-col cols="6">
              <label-required-field label="Target" />
              <b-input v-model="target" />
            </b-col>
            <b-col cols="12">
              <label-required-field label="Descrição" />
              <b-textarea v-model="description" />
            </b-col>
            <b-col cols="12">
              <label>Ações</label>
              <b-checkbox-group
                :options="actions_list"
                v-model="actions"
                text-field="name"
                value-field="id"
              />
            </b-col>
          </b-row>
          <b-row align-h="end">
            <b-col cols="auto">
              <v-btn class="v-primary ml-1" @click="show = false">
                <v-icon class="mr-1">mdi-arrow-left</v-icon>
                VOLTAR
              </v-btn>
              <v-btn type="submit" class="v-success ml-1">
                <v-icon class="mr-1">mdi-check</v-icon>
                SALVAR
              </v-btn>
            </b-col>
          </b-row>
        </b-form>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import toast from "../../components/ToastNotification";
import api from "../../services/api";
import ErrorsMessages from "../components/ErrorsMessages.vue";
import LabelRequiredField from "../components/LabelRequiredField.vue";
import WarningRequiredFields from "../components/WarningRequiredFields.vue";
import NewGroup from "./NewGroup.vue";

export default {
  name: "NewPermission",
  components: {
    LabelRequiredField,
    ErrorsMessages,
    WarningRequiredFields,
    NewGroup,
  },
  props: {
    toggle: Boolean,
  },
  data: () => ({
    errors: [],

    show: false,
    loading: false,

    show_new_group: false,

    module_id: "",
    group_id: "",
    name: "",
    target: "",
    description: "",
    actions: [],

    modules: [],
    groups: [],
    actions_list: [],
  }),
  watch: {
    toggle: function () {
      this.show = true;
    },
  },
  methods: {
    async evOnShow() {
      this.errors = [];
      this.module_id = "";
      this.group_id = "";
      this.name = "";
      this.target = "";
      this.description = "";
      this.actions = [];
      await this.getModules();
      await this.getGroups();
      await this.getActions();
    },
    async evOnShown() {
      this.$refs.autofocus.focus();
    },
    async evOnHide() {
      this.show = false;
    },

    async evOnSubmit() {
      this.loading = true;

      try {
        const data = {
          module_id: this.module_id,
          group_id: this.group_id,
          name: this.name,
          target: this.target,
          description: this.description,
          actions: this.actions,
        };
        const response = await api.post(
          "/admin/rest-home/default/permission",
          data
        );
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.show = false;
          toast(message, "success");
          this.$emit("created");
        }
      } catch (error) {
        console.log(error);
      }

      this.loading = false;
    },

    async getModules() {
      this.loading = true;

      try {
        const response = await api.get("/admin/module/all");
        const { error, errors, modules } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.modules = modules;
        }
      } catch (error) {
        console.log(error);
      }

      this.loading = false;
    },

    async getGroups() {
      this.loading = true;

      try {
        const response = await api.get(
          "/admin/rest-home/default/permission/groups"
        );
        const { error, errors, groups } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.groups = groups;
        }
      } catch (error) {
        console.log(error);
      }

      this.loading = false;
    },

    async getActions() {
      this.loading = true;

      try {
        const response = await api.get(
          "/admin/rest-home/default/permissions/actions"
        );
        const { error, errors, actions } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.actions_list = actions;
        }
      } catch (error) {
        console.log(error);
      }

      this.loading = false;
    },
  },
};
</script>

<style>
</style>